import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpUtils } from '../utils/httpUtils';
import { Defrost } from '../model/defrost';

@Injectable({
  providedIn: 'root'
})
export class ExecutionQTestDefrostService {

  readonly urlBase = `${environment.qualificatesUrl}/executionQTestDefrost`
  constructor(private http: HttpClient) {
  }

  findAllFromEssay(idEssay: number): Observable<any> {
    const url =  `${this.urlBase}/essay/${idEssay}`;

    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  findOne(id: number): Observable<any> {
    const url = `${this.urlBase}/${id}`;

    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  save(defrost: Defrost): Observable<any> {
    let url = `${this.urlBase}/`;

    if (defrost.id != null) {
      url += defrost.id;

      return this.http.put(url, defrost).pipe(map(httpRes => HttpUtils.extractData(httpRes)))
    } else {
      url += 'create';

      return this.http.post(url, defrost).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
    }
  }

  delete(id: number): Observable<any> {
    const url =  `${this.urlBase}/${id}`;

    return this.http.delete(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }
}
